module.exports = __webpack_public_path__ + "img/BRACELET.151f7dfc.webp";